export {
  AssetRepository,
  assetRepository,
} from './repository';
export type { IAssetRepository } from './repository';

// Export entities
export { AssetEntity } from './asset.entity';

// Export hooks
export {
  assetKeys,
  useAssets,
  useAssetHistoryPaginated,
  useAssetsByCatalogIds,
  useAssetsByIds,
  useAssetsPaginated,
  useAssetsPaginatedAll,
  useCreateAsset,
  useUpdateAsset,
} from './hooks';

export { useRealtimeAssetUpdates } from './realtime-hooks';

// Export types used by consumers
export type {
  CreateAssetDto,
  UpdateAssetDto,
} from '@peritasai/types';
